import { Controller } from '@hotwired/stimulus';

// Accessoires de sécurité d'un ESP : « Ajouter » révèle la première ligne
// vide masquée ; « Retirer » vide une ligne nouvelle et la masque à nouveau.
// Le bouton « Ajouter » disparaît quand aucune ligne n'est masquée ; le texte
// « Aucun accessoire » paraît quand toutes le sont.
export default class extends Controller {
    static targets = ['row', 'add', 'empty'];

    add() {
        const row = this.rowTargets.find((candidate) => candidate.hidden);
        if (!row) return;
        row.hidden = false;
        this.refresh();
        row.querySelector('[role="combobox"], input:not([type=hidden])')?.focus();
    }

    remove({ currentTarget }) {
        const row = currentTarget.closest('[data-safety-accessories-target="row"]');
        row.querySelectorAll('input:not([type=hidden]), select').forEach((field) => {
            field.value = '';
            if (field.tagName === 'SELECT') field.dispatchEvent(new CustomEvent('combobox:render', { bubbles: true }));
        });
        row.hidden = true;
        this.refresh();
        this.addTarget.focus();
    }

    refresh() {
        this.addTarget.hidden = !this.rowTargets.some((row) => row.hidden);
        this.emptyTarget.hidden = this.rowTargets.some((row) => !row.hidden);
    }
}
